import React, { useState, useEffect } from 'react';
import { Button, Form, Col, Modal, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import Toaster from '../../Toaster/Toaster';
import Loader from '../../Loader/Loader';
import callAPI from '../../../../commonservices/APIRequests';
import { getSharedNotes } from '../../../../store/Actions/Notes';
import './CreateNote.css'
import { setApiRefresh } from '../../../../store/Reducers/Shared';
import { FileText, X } from 'lucide-react';
import TextAreaField from '../../common/components/Shared_FormControls/TextAreaField/TextAreaField';
import SelectBox from '../../common/components/Shared_FormControls/SelectBox/SelectBox';
import popupHeaderIcon from '../../../../assets/images/Popup-Icons/PopupIcons_NotesWhite.svg';
import EditNotePopupwhite from '../../../../assets/images/Popup-Icons/PopupIcons_EditNoteWhiteIcon.svg';
import ReactQuill from 'react-quill';
import { viewDocument, fileToBase64, checkFileFormat, payloadFileFormat } from "../../../../commonservices/CommonMethods";
import { useRef } from 'react';
import deleteIcon from '../../../../assets/images/Action-Icons/Close-Icon.svg'
import eyeIcon from '../../../../assets/images/Action-Icons/Eye-Icon.svg'
import fileUploadIcon from '../../../../assets/images/Popup-Icons/PopupIcons_UploadClipIcon.svg';
import { getNotetagData } from '../../../../store/Actions/Actions';
import InfoIcon from '../../../../assets/images/info-icon-v2.svg'
import "react-quill/dist/quill.snow.css";

const CreateNote = (props) => {
    const inputRef = useRef();
    const { noteTagData, isLoaded} = useSelector((store) => store.sharedReducer);
    const [validate, setValidate] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [formDataCN, setFormDataCN] = useState({});
    const [noteError, setNoteError] = useState(false);
    const [docfile, setFile] = useState({});
    const [toaster, setToaster] = useState({
        header: '',
        class: '',
        content: '',
        showToaster: false
    });
    const [vehicleID, setVehicleID] = useState('')
    const dispatch = useDispatch();
    const notesType = [
        {
            label: 'Dealer Note',
            value: 'Dealer Note'
        },
        {
            label: 'Asset Note',
            value: 'Vehicle Note'
        },
        {
            label: 'Title Note',
            value: 'Title Note'
        },
        {
            label: 'Audit Note',
            value: 'Audit Note'
        },
        {
            label: 'Payment Note',
            value: 'Payment Note'
        },
        {
            label: 'Supplier Note',
            value: 'Supplier Note'
        },
        {
            label: 'History',
            value: 'History'
        },
    ]
    // notes editor formattter 
    const modules = {
        toolbar: [
            [{ font: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
            ["link"],
            //["link", "image", "video"],
            ["clean"],
        ],
    };

    const viewDocumentById = (item) => {
        setShowLoader(true)
        return callAPI.post('/lender/api/v1/dealer/getTitleDocumentUrl', { _id: item._id, noteType: formDataCN.noteType ? formDataCN.noteType : props.noteType }).then((response) => {
            if (response.status === 200) {
                setShowLoader(false)
                viewDocument(response.data.fileType, response.data.url)
            } else {
                setShowLoader(false)
                console.log(response.message)
            }
        })

    }

    const deleteDocumentById = (item) => {
        setShowLoader(true)
        return callAPI.delWithParams('/lender/api/v1/dealer/deleteNotesDocument', { noteId: item._id, noteType: formDataCN.noteType ? formDataCN.noteType : props.noteType }).then((response) => {
            if (response.status === 200) {
                inputRef.current.value = "";
                setShowLoader(false)
                dispatch(getSharedNotes(props.dealerIDForEdit, formDataCN.noteType ? formDataCN.noteType : props.noteType, !props.restrictVehicleId ? (vehicleID ? vehicleID : props.vehicleId) : ''));
                setFile({});
            } else {
                setShowLoader(false)
                console.log(response.message)
            }
        })

    }

    const uploadFile = async (event) => {
        const file = event.target.files[0];
        if (file.size > 10485760) {
            setToaster({
                header: 'Error',
                class: 'error-toaster',
                content: 'File size is too large, please upload a file smaller than 10MB.',
                showToaster: true
            });
            return;
        }
        const isValid = checkFileFormat(file, setToaster, ['.pdf', '.jpg', '.jpeg', '.png', '.heic']);

        if (!isValid) {
            // Stop further execution because the file format is invalid
            return;
        }
        const fileDetails = {
            fileName: file.name,
            base64Image: await fileToBase64(file),
            fileType: payloadFileFormat(file.name, file.type),
        }
        setFile(fileDetails)
    }


    const toasterClose = () => {

        setToaster({
            header: '',
            class: '',
            content: '',
            showToaster: false
        })

    };

    const twoWayBindCN = (key, value) => {
                setFormDataCN({
            ...formDataCN,
            [key]: value
        });
    }


    const onChangeNotesContent = (value) => {
        if (validate) {
            if (value && value.replace(/p{|margin: 0|}|<[^>]*>?|&nbsp;/gm, '').trim().length > 0) {
                setNoteError(false);
            } else if (formDataCN && formDataCN.notes && formDataCN.notes.replace(/p{|margin: 0|}|<[^>]*>?|&nbsp;/gm, '').trim().length === 0) {
                setNoteError(true);

            }
        }

        setFormDataCN((prev) => {
            return {
                ...prev,
                "notes": value
            }
        })
    }

    useEffect(() => {
        if (!noteTagData || !noteTagData.length) {
            dispatch(getNotetagData())
        }
    }, [])

    useEffect(() => {
        
        if (props.action === 'editNote' && props?.showModalCN) {
            setFormDataCN({
                noteTag: props.data && props.data.noteTag ? props.data.noteTag : '',
                notes: props.data && props.data.notes ? props.data.notes : '',
            })
            if (props.data.document && Object.keys(props.data.document).length > 0) {
                setFile({
                    fileName: props.data && props.data.document.fileName ? props.data.document.fileName : '',
                })
            }
        } else if (props.noteTag && ['Subscription', 'Risk'].includes(props.noteTag)) {
            setFormDataCN({
                noteTag: props.noteTag,
            })
        }
        else {
            setFormDataCN({});
        }

    }, [props.data, props.showModalCN])


    const createNoteHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setValidate(true);
        let isReturn = false;

        if (formDataCN?.notes?.replace(/p{|margin: 0|}|<[^>]*>?|&nbsp;/gm, '').trim().length > 0) {
            isReturn = false;
            setNoteError(false);
        }
        else {
            isReturn = true;
            setNoteError(true);
        }

        if (!formDataCN.noteTag)
            isReturn = true;

        if (isReturn) return;

        const form = event.currentTarget;

        if (form.checkValidity() !== false) {
            setShowLoader(true);
            let req;
            if (!props.action) {
                switch (formDataCN?.noteType || props?.noteType) {
                    case "Dealer Note":
                        req = {
                            noteType: formDataCN.noteType ? formDataCN.noteType : props.noteType,
                            notes: formDataCN.notes,
                            dealer_id: props.data.dealerId,
                            noteTag: formDataCN.noteTag ? formDataCN.noteTag : (props.noteTag ? props.noteTag : 'Other'),
                            addedFrom: props.data.addedFrom
                        }

                        if (props.subscriptionNotes) {
                            req.subscriptionMonth = props.subscriptionRequest.month;
                            req.subscriptionYear = props.subscriptionRequest.year
                        }
                        if (props.isVehicleDetails)
                            req.vehicleId = props.data.vehicleId ? props.data.vehicleId : props.data._id;

                        if (props.data.addedFrom && props.data.addedFrom === 'RISK_ALERTS')
                            req.riskAlertId = props.data._id;


                        if (props.data?.subscriptionNotes) {
                            req.subscriptionMonth = props.data?.subscriptionNotes?.month;
                            req.subscriptionYear = props.data?.subscriptionNotes?.year
                        }

                        break;
                    case "Vehicle Note":
                        req = {
                            noteType: formDataCN.noteType ? formDataCN.noteType : props.noteType,
                            notes: formDataCN.notes,
                            dealer_id: props.data.dealerId ? props.data.dealerId : props.data.dealer_id,
                            noteTag: formDataCN.noteTag ? formDataCN.noteTag : (props.noteTag ? props.noteTag : 'Other'),
                            vin: props.data.vin,
                            addedFrom: props.isVehicleDetails ? "FULL_VEHICLE_DETAILS" : "LENDER_FUNDING_REQUEST",
                            facilityId: props.data.facilityId,
                            vehicleName: props.data.vehicleName,
                            vehicleId: props.data.vehicleId ? props.data.vehicleId : props.data?.leverVehicleId,
                        }

                        if (!req.vehicleId) {
                            req.vehicleId = props.data.id
                        }

                        break;
                    case "Payment Note":
                        req = {
                            noteType: formDataCN.noteType ? formDataCN.noteType : props.noteType,
                            notes: formDataCN.notes,
                            dealer_id: props.data.dealerId,
                            noteTag: formDataCN.noteTag ? formDataCN.noteTag : (props.noteTag ? props.noteTag : 'Other'),
                            addedFrom: props.isVehicleDetails ? "FULL_VEHICLE_DETAILS" : "PAYMENTS",
                            paymentId: props.data._id,
                            vehicleName: props.data.vehicleName,
                            vehicleId: props.data.vehicleId,
                            vin: props.data.vin,
                            paymentDescription: props.data.description && props.data.description.title,
                            paymentAmount: props.data.paymentAmount,
                            paymentDate: props.data.dueDate
                        }
                        break;
                    case "Title Note":
                        req = {
                            noteType: formDataCN.noteType ? formDataCN.noteType : props.noteType,
                            notes: formDataCN.notes,
                            dealer_id: props.data.dealerId,
                            noteTag: formDataCN.noteTag ? formDataCN.noteTag : (props.noteTag ? props.noteTag : 'Other'),
                            addedFrom: props.isVehicleDetails ? "FULL_VEHICLE_DETAILS" : "TITLE_ALERTS",
                            paymentId: props.data._id,
                            vehicleName: props.data.vehicleName,
                            vehicleId: props.data.vehicleId ? props.data.vehicleId : props.data._id,
                            vin: props.data.vin,
                            titleStatus: props.data.titleStatus,
                        }
                        break;
                    case "Audit Note":
                        req = {
                            noteType: formDataCN.noteType ? formDataCN.noteType : props.noteType,
                            notes: formDataCN.notes,
                            vehicleId: props.data.vehicleId ? props.data.vehicleId : props.data._id,
                            dealer_id: props.data.dealerId,
                            vin: props.data?.chassis,
                            audit_id: props.data.audit_id ? props.data.audit_id : props.data._id,
                            addedFrom: props.isVehicleDetails ? "FULL_VEHICLE_DETAILS" : "AUDITS",
                            noteTag: formDataCN.noteTag ? formDataCN.noteTag : (props.noteTag ? props.noteTag : 'Other'),
                            vehicleName: props.data.vehicleName
                        }
                        break;
                    case "Supplier Note":
                        req = {
                            noteType: formDataCN.noteType ? formDataCN.noteType : props.noteType,
                            notes: formDataCN.notes,
                            supplierId: props.data._id,
                            noteTag: formDataCN.noteTag ? formDataCN.noteTag : (props.noteTag ? props.noteTag : 'Other'),
                            addedFrom: props.data.addedFrom
                        }
                        break;
                }
            } else {
                req = {
                    noteType: formDataCN.noteType ? formDataCN.noteType : props.noteType,
                    noteId: props.data._id,
                    noteTag: formDataCN.noteTag ? formDataCN.noteTag : (props.noteTag ? props.noteTag : 'Other'),
                    notes: formDataCN.notes
                }
            }

            if (Object.keys(docfile).length > 0) {
                req.document = docfile
            }
            setVehicleID(req.vehicleId)
             let Api = props.isTitleInventory ? '/tms/api/v1/inventory/createNotes' : '/lender/api/v1/lender/createNotes'
            return callAPI.post(Api, req)
                .then((response) => {
                    if (response.status === 200) {
                        setValidate(false);
                        setShowLoader(false);
                        setFormDataCN({});
                        setFile({})
                        if (req.riskAlertId && props.updateNotesInParent) {
                            props.updateNotesInParent(req.riskAlertId, req.notes)
                        }
                        else if (props.updateNotesInParent) {
                            props.updateNotesInParent(req.notes)
                        }

                        if (props.updateNotesTextByDealer) {
                            props.setNotesDealerId(req.dealer_id);
                            props.setNotesTextUpdate(req.notes);
                        }
                        else if (props.updateNotesText) {
                            props.setNotesVehicleId(req.vehicleId);
                            props.setNotesText(req.notes);
                        }
                        else if (props.showPaymentNotesLatest) {
                            props.setNotesPaymentId(req.paymentId);
                            props.setNotesTextUpdate(req.notes);
                        }
                        else if (props.updateOnlyNotesText) {
                            props.setNotesText(req.notes);
                        }

                        props.cancelCN();
                        if (props.action === 'editNote' || props.subscriptionNotes) {
                            dispatch(setApiRefresh(true));
                        }
                        if (props.action || props.getNotesCall)
                            dispatch(getSharedNotes(props.dealerIDForEdit, formDataCN.noteType ? formDataCN.noteType : props.noteType, !props.restrictVehicleId ? (req.vehicleId ? req.vehicleId : props.vehicleId) : '', null, props.isTitleInventory));
                    }

                    else {
                        setFile({})
                        setShowLoader(false);
                        setValidate(false);
                        setFormDataCN({})
                        setToaster({
                            header: 'Error',
                            class: 'error-toaster',
                            content: response.message,
                            showToaster: true
                        });

                    }

                    setValidate(false);

                })
        }
    }

    const closepopupHandler = () => {
        setFormDataCN({});
        setFile({})
        props.cancelCN()
        setValidate(false);
        setNoteError(false);
    }

    return (
        <Modal className={`notes-popup default-popup modal-backdrop-bg-color default-medium-popup`} show={props.showModalCN}
            onHide={() => closepopupHandler()} backdrop={props.isStatic ? "static" : null} centered={props.centered}>
            <Modal.Header className='darkblue-bg-color' closeButton={props.isStatic ? false : true}>
                <Modal.Title>
                    {props.icon ? props.icon : <span className='popup-title-icon'><Image src={props.action === 'editNote' ? EditNotePopupwhite : popupHeaderIcon} alt='icon' fluid /></span>}
                    <span className='flex-grow-1'>{props.action === 'editNote' ? 'Update Note' : 'Create Note'}</span>
                    <span className='popup-close-icon'><X size={20} /></span>
                </Modal.Title>
                <Loader show={props.showPopupLoader} styleType='absolute' />
            </Modal.Header>
            <Modal.Body>
                <Loader show={showLoader} styleType='fixed' />
                <p className='dealer-name-popup'>{props.data?.dealerName ? props.data?.dealerName : null} {props.data?.sopraDealerReference ? '(' + props.data?.sopraDealerReference + ')' : null}</p>
                <p className='dealer-name-popup'>{props.data?.vehicleName ? props.data?.vehicleName : null}</p>
                <p className="mb-3">{props.data?.vin ? props.data?.vin : null}</p>
                {
                    toaster.showToaster ?
                        <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                        : null
                }
                <Form noValidate
                    validated={validate}
                    onSubmit={(event) => createNoteHandler(event)}
                >

                    <Form.Row>
                        {props.noteType !== 'Supplier Note' ?
                            < Form.Group as={Col} className="col-md-6">
                                <SelectBox
                                    required
                                    label='Note Type'
                                    name="NoteType"
                                    validated={validate}
                                    objectKey='noteType'
                                    value={formDataCN.noteType && props.isVehicleDetails ? formDataCN.noteType : (props.noteType ? props.noteType : '')}
                                    // value={props.noteType ? props.noteType : formDataCN.noteType}
                                    onChange={(key, value) => twoWayBindCN(key, value)}
                                    options={props.noteType !== 'Supplier Note' ? notesType.filter((value) => value.label !== 'Supplier Note') : notesType}
                                    // disabled={props.noteType ? true : false}
                                    disabled={props.isVehicleDetails ? false : true}
                                />
                            </Form.Group> : null}
                        <Form.Group as={Col}>
                            <Loader show={!isLoaded} styleType='absolute' />
                            <SelectBox
                                label='Add Tag'
                                name="NoteTag"
                                validated={validate}
                                objectKey="noteTag"
                                required
                                disabled={props.data?.recoveryAmount ? true : false}
                                value={formDataCN.noteTag ? formDataCN.noteTag : (props.noteTag ? props.noteTag : (props.data.noteTag ? props.data.noteTag : ''))}
                                onChange={(key, value) => twoWayBindCN(key, value)}
                                options={noteTagData}
                            />
                        </Form.Group>


                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}>
                            {/* <TextAreaField
                                label='Take Notes'
                                required
                                objectKey='notes'
                                name='Notes'
                                placeholder=""
                            value={formDataCN.notes ? formDataCN.notes : ''}
                            onChange={(key, value) => twoWayBindCN(key, value)}
                            /> */}
                            <ReactQuill

                                theme="snow"
                                modules={modules}
                                value={formDataCN.notes ? formDataCN.notes : ''}
                                onChange={onChangeNotesContent}
                            />
                            {noteError ? <span className='custom-error-message'> Please enter a note.</span> : null}
                            <div className="default-document-item mt-3">
                                <div className="default-document-label">
                                    <Image src={fileUploadIcon} alt="additioncost-image" />
                                    <p className={`default-document-label ${Object.keys(docfile).length !== 0 ? 'secondary-text-color cursor-not-allowed' : ''}`}>Choose your Document or Drop your Document</p>
                                </div>
                                {Object.keys(docfile).length === 0 ?
                                    <input type="file" ref={inputRef} onChange={(event) => uploadFile(event)} id="input-file-now" className="file-upload" />
                                    :
                                    <input type="file" ref={inputRef} id="input-file-now" className="file-upload" disabled />
                                }

                            </div>
                            <small className='secondary-text-color d-flex align-items-center mt-1'>
                                <Image src={InfoIcon} alt='info' className='common-info-icon' />
                                <span className='ml-1'>Allowed types: PDF, JPG, JPEG, PNG, HEIC</span>
                            </small>
                            {docfile.fileName ? <small className='mt-1 d-inline-block'>{docfile.fileName.substring(docfile.fileName)}
                                {docfile.fileType ?

                                    <React.Fragment>
                                        <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip>View</Tooltip>}>
                                            <Image src={eyeIcon} className="cursor-pointer ml-1" onClick={() => viewDocument(docfile.fileType, docfile.base64Image)} alt="viewIcon" />
                                        </OverlayTrigger>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip>View</Tooltip>}>
                                            <Image src={eyeIcon} className="cursor-pointer ml-1" onClick={() => viewDocumentById(props.data)} />
                                        </OverlayTrigger>
                                    </React.Fragment>

                                }
                                {props.action !== 'editNote' ?
                                    <React.Fragment>
                                        <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip>Delete</Tooltip>}>
                                            <Image src={deleteIcon} className="cursor-pointer ml-1" onClick={() => { inputRef.current.value = ""; setFile({}) }} />
                                        </OverlayTrigger>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip>Delete</Tooltip>}>
                                            <Image src={deleteIcon} className="cursor-pointer ml-1" onClick={() => { deleteDocumentById(props.data) }} />
                                        </OverlayTrigger>
                                    </React.Fragment>
                                }</small> : null}
                        </Form.Group>
                    </Form.Row>
                    <div className="text-xs-center d-flex justify-content-start">
                        <Button type="submit" variant="primary" className="default-btn">{props.action === 'editNote' ? 'Update' : 'Add'}</Button>
                        <Button type="button" onClick={closepopupHandler} variant="outline-secondary" className="default-btn ml-3">Cancel</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}



export default CreateNote;